import { createGlobalStyle } from 'styled-components'

export const GlobalStyles = createGlobalStyle`
  /* General PrimeReact input/button focus */
  .p-inputtext:focus,
  .p-inputnumber-input:focus,
  .p-dropdown:focus,
  .p-button:focus,
  .p-checkbox-box:focus,
  .p-radiobutton-box:focus,
  .p-selectbutton-button:focus,
  .p-calendar:focus,
  .p-spinner-input:focus {
    outline: 0 !important;
    box-shadow: 0 0 0 0.2rem #ba9d31 !important;
  }

  /* Dropdown container focus (wrapper div) */
  .p-dropdown.p-inputwrapper-focus {
    box-shadow: 0 0 0 0.2rem #ba9d31 !important;
    outline: none !important;
    border-color: #ba9d31 !important;
  }

  /* Dropdown label inside */
  .p-dropdown-label:focus {
    outline: none !important;
    box-shadow: 0 0 0 0.2rem #ba9d31 !important;
  }

  /* Dropdown trigger button focus */
  .p-dropdown-trigger:focus {
    outline: none !important;
    box-shadow: 0 0 0 0.2rem #ba9d31 !important;
  }

  /* Dropdown selected + focused item background */
  .p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight.p-focus {
    background: rgba(186, 157, 49, 0.24); /* ba9d31 with 24% opacity */
  }

  /* Dropdown selected item background + color */
  .p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
    color: #495057;
    background: #f4e8b0; /* a light gold-ish background matching ba9d31 */
  }
`
